import React from 'react'
import './css/ServicesHero.css'
import Navbar from './Navbar'
import Food from './../assets/images/ServicesFood.png'
import { Link } from 'react-router-dom'

function ServicesHero() {
  return (
    <div className='ServicesHero'>
        <div className='overlay'></div>
        <Navbar className='navbar'/>
        <div className='content'>
          <div className='left'>
              <p className='winner'>What we offer</p>
              <h1>Discover our<br/> Range of services</h1>
              <Link to="/contact"><button className='cta'>Contact us</button></Link>
          </div>
          <div className='right'>
              <img className='food' src={Food} alt='Food' />
          </div>
        </div>
    </div>
  )
}

export default ServicesHero